import NewMedicalDocument from "../utils/medicalDocument/new";
import MedicineForm from "./form/medicine";
import DateForm from "./form/Date";

export default () => <NewMedicalDocument
  module={{ name: "orden", basePath: "orders" }}
  MedicineForm={MedicineForm}
  DateForm={DateForm}
/>;